import { Tabs } from "antd";
import React from "react";
import { Link } from "react-router-dom";
import { strings } from "../../helpers";
import ClinicBasicInfoContainer from "../ClinicDetailsComponents/BasicInfo/ClinicBasicInfoContainer";
import MetricsContainer from "../ClinicDetailsComponents/Metrics/MetricsContainer";
import DoctorsContainer from "../ClinicDetailsComponents/Doctors/DoctorsContainer";
import StaffContainer from "../ClinicDetailsComponents/Staff/StaffContainer";
import LocationsContainer from "../ClinicDetailsComponents/Locations/LocationsContainer";
import BankDetailsContainer from "../ClinicDetailsComponents/Bank/BankDetailsContainer";
import AdminsContainer from "../ClinicDetailsComponents/Admins/AdminsContainer";

const { TabPane } = Tabs;

export default class ClinicDetailsTabView extends React.Component {
  render() {
    const {
      currentPath,
      details,
      clinicId,
      refreshClinicDetails,
      handleEditLocation,
      getClinicInfo
    } = this.props;

    const basicInfo = `/clinics-details/${clinicId}/basic-details`;
    const metrics = `/clinics-details/${clinicId}/metrics`;
    const doctors = `/clinics-details/${clinicId}/doctors`;
    const staff = `/clinics-details/${clinicId}/staff`;
    const locations = `/clinics-details/${clinicId}/locations`;
    const bankDetails = `/clinics-details/${clinicId}/bank-details`;
    const admins = `/clinics-details/${clinicId}/admins`;

    return (
      <div className="kc-tabs-view appointment-content-container">
        <Tabs
          type="card"
          className="px-10 line-tabs"
          activeKey={
            currentPath === "basic-details" ? "basic-details" : currentPath
          }
        >
          <TabPane
            key="basic-details"
            tab={<Link to={basicInfo}>Details</Link>}
          >
            <ClinicBasicInfoContainer
              details={details}
              handleEditLocation={handleEditLocation}
            />
          </TabPane>
          <TabPane key="metrics" tab={<Link to={metrics}>Metrics</Link>}>
            <MetricsContainer details={details} />
          </TabPane>
          <TabPane key="doctors" tab={<Link to={doctors}>Doctors</Link>}>
            <DoctorsContainer details={details} getClinicInfo={getClinicInfo} />
          </TabPane>
          <TabPane key="staff" tab={<Link to={staff}>Staff</Link>}>
            <StaffContainer details={details} />
          </TabPane>
          <TabPane key="locations" tab={<Link to={locations}>Locations</Link>}>
            <LocationsContainer
              details={details}
              refreshClinicDetails={refreshClinicDetails}
            />
          </TabPane>
          <TabPane
            key="bank-details"
            tab={<Link to={bankDetails}>Bank Details</Link>}
          >
            <BankDetailsContainer details={details} />
          </TabPane>
          <TabPane key="admins" tab={<Link to={admins}>Admins</Link>}>
            <AdminsContainer clinicId={clinicId} />
          </TabPane>
        </Tabs>
      </div>
    );
  }
}
